function generate_calculation ( args ) {

  var calc_variables = {};
  for ( index in args['variables'] ) {
    var variable = args['variables'][ index ];
    calc_variables[ variable ] = $("[id$='." + variable + "']");
  }

  $("[id$='." + args['target_id'] + "']").calc(
    // the equation to use for the calculation
    args['equation'],

    // define the variables used in the equation, these can be a jQuery object
    calc_variables,

    // define the formatting callback, the results of the calculation are passed to this function
    function (s){
      if ( isNaN(s) ) {
        return '-';
      } 

      var formatting = args['formatting'];

      if ( formatting['precision'] != undefined ) {
        s = s.toFixed( formatting['precision'] );
      }

      if ( formatting['symbol'] != undefined ) {
        s = formatting['symbol'] + s;
      }

      return s;
    },

    // define the finish callback, this runs after the calculation has been complete
    function ($this){
      var final_callbacks = args['final_callbacks'];

      for ( index in final_callbacks ) {
        var callback = final_callbacks[index];
        window[callback]();
      }
    }
  );
} 
